import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  data: [],
  error: null,
  loading: false,
  facility: null,
  exportStatus: { loading: false, error: null },
}

const facilitySlice = createSlice({
  name: "facility",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload
    },
    setFacililty(state, action) {
      state.facility = action.payload
    },
    setExportStatus(state, action) {
      state.exportStatus = {
        loading: action.payload.loading,
        error: action.payload.error,
      }
    },
    resetState(state) {
      state.data = []
      state.error = null
      state.loading = false
      state.facility = null
      state.exportStatus = { loading: false, error: null }
    },
  },
})

export const facilityAction = facilitySlice.actions

export default facilitySlice
